import { createElementBlock as l, openBlock as o, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(c, e) {
  return o(), l("svg", r, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.103 3c-2.277 0-4.764 1.485-4.764 4.295 0 1.227.433 1.938.77 2.492l.022.036c.125.205.235.387.32.589H7.338a1 1 0 1 0 0 2h2.134c-.1.381-.24.818-.418 1.29a30 30 0 0 1-1.153 2.62C7.31 17.525 8.161 19 9.554 19h7.255a1 1 0 1 0 0-2H9.796c.356-.732.78-1.664 1.13-2.595.241-.641.468-1.338.597-1.993h3.639a1 1 0 1 0 0-2h-3.627c-.148-.72-.442-1.213-.695-1.63l-.008-.012c-.302-.497-.493-.81-.493-1.475C10.339 5.967 11.512 5 13.103 5c1.448 0 2.621 1.014 2.708 2.359a1 1 0 1 0 1.996-.13C17.642 4.684 15.449 3 13.103 3",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const a = { render: t };
export {
  a as default,
  t as render
};
//# sourceMappingURL=ic_pound-BwkcRKLE.js.map
